import { Checkbox as ChakraCheckbox } from "@chakra-ui/react";
import * as React from "react";

export interface CheckboxProps extends ChakraCheckbox.RootProps {
    icon?: React.ReactNode;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    rootRef?: React.Ref<HTMLLabelElement>;
    controlStyles?: ChakraCheckbox.ControlProps;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    (props, ref) => {
        const {
            icon,
            children,
            inputProps,
            rootRef,
            css,
            controlStyles,
            ...rest
        } = props;
        return (
            <ChakraCheckbox.Root ref={rootRef} {...rest} css={css}>
                <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
                <ChakraCheckbox.Control {...controlStyles}>
                    {icon || <ChakraCheckbox.Indicator />}
                </ChakraCheckbox.Control>
                {children != null && (
                    <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>
                )}
            </ChakraCheckbox.Root>
        );
    },
);
